import { useState } from 'react';
import { CapitolKeyItem } from './capitol-key-item';
import { Key } from '@/types';
import { Button } from '@/components/ui/button';
import { ApiKeysSkeleton } from './api-keys-skeleton';
import { PageTitle } from '@/components/page-title';
import { PageDescription } from '@/components/page-description';
import { AddCapitolKeyModal } from './add-capitol-key';
import { useGetCapitolKeys } from '@/hooks/queries/keys/use-get-capitol-keys';

interface KeysListProps {
  title: string;
  description?: string;
}

export const KeysList = ({ title, description }: KeysListProps) => {
  const { data = [], isPending } = useGetCapitolKeys();

  const [isCapitolApikeyModalOpen, setIsCapitolApikeyModalOpen] =
    useState(false);

  if (isPending) {
    return <ApiKeysSkeleton />;
  }

  return (
    <div className='w-full'>
      <div className='flex justify-between items-start mb-4 gap-4'>
        <div className='flex-1 min-w-0'>
          <PageTitle id='api-keys-title' title={title} />
          {description && <PageDescription>{description}</PageDescription>}
        </div>
        <div className='shrink-0 flex gap-2'>
          <Button
            id='api-keys-generate'
            onClick={() => setIsCapitolApikeyModalOpen(true)}
          >
            Generate API key
          </Button>
        </div>
      </div>

      {data.length === 0 && (
        <p id='api-keys-empty' className='text-zinc-500 dark:text-zinc-50'>
          There are no API keys associated with your account.
        </p>
      )}
      <div className='flex flex-col gap-2'>
        {data.map((item: Key) => (
          <CapitolKeyItem apiKey={item} key={item.id} />
        ))}
      </div>
      <AddCapitolKeyModal
        isOpen={isCapitolApikeyModalOpen}
        setIsApikeyModalOpen={setIsCapitolApikeyModalOpen}
      />
    </div>
  );
};
